/**
 * Textos das mensagens da Prospecção, editáveis na tela e guardados neste navegador
 * (localStorage), para trocar o texto sem novo build. Sem texto salvo, vale o padrão
 * abaixo.
 *
 * Primeira mensagem (teste A/B, "conversa" e "link"): quem é + uma coisa concreta que o
 * sistema faz + uma pergunta que se responde com "pode". Duas frases, sem lista de
 * funções (2026-10-21: o texto longo caía na fila de pacientes da clínica e morria).
 * "retorno": lembrete único para quem não respondeu, sem pergunta sobre o negócio.
 *
 * Variáveis, trocadas por contato na hora do envio:
 *   {saudacao}      Bom dia / Boa tarde / Boa noite, pela hora de quem envia
 *   {publico}       para quem é, pela categoria (ex.: fisioterapeutas)
 *   {atendimentos}  como se chama o atendimento (ex.: sessões)
 *   {link}          site com o link curto da versão (?ref=a / ?ref=b / ?ref=c, vira utm_campaign=prospeccao_<versão>)
 */

const STORAGE_KEY = 'gabriela.admin.prospects.templates.v1';

const OPENING = '{saudacao}, aqui é o Lucca, criador da Gabriela, um sistema que deixa a confirmação de {atendimentos} pronta para mandar pelo WhatsApp num clique e junta agenda, prontuário e financeiro num lugar só.';

// O link fica no fim: a Z-API monta o cartão de prévia (send-link) a partir dele
export const DEFAULT_TEMPLATES = {
  conversa: [
    OPENING,
    'Posso te mandar o link para você dar uma olhada quando der?',
  ].join('\n\n'),
  link: [
    OPENING,
    'Se fizer sentido para a sua rotina, dá para testar 30 dias grátis, sem cartão: {link}',
  ].join('\n\n'),
  retorno: [
    'Oi! Passando só para a mensagem não ficar perdida. Se não for o momento, tudo bem, não insisto.',
    'Se quiser ver a Gabriela funcionando: {link}',
  ].join('\n\n'),
};

export const TEMPLATE_TOKENS = [
  { token: '{saudacao}', label: 'Bom dia / Boa tarde / Boa noite' },
  { token: '{publico}', label: 'ex.: fisioterapeutas' },
  { token: '{atendimentos}', label: 'ex.: sessões' },
  { token: '{link}', label: 'link curto do site, já marcado com a versão' },
];

/** @returns {{ conversa: string, link: string, retorno: string }} textos salvos, ou o padrão de cada um */
export function loadTemplates() {
  let saved = {};
  try {
    saved = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}') || {};
  } catch (e) {
    saved = {};
  }
  const templates = {};
  Object.keys(DEFAULT_TEMPLATES).forEach((key) => {
    templates[key] = String(saved[key] || '').trim() || DEFAULT_TEMPLATES[key];
  });
  return templates;
}

/**
 * Texto igual ao padrão não é salvo, para uma mudança futura no padrão valer.
 * @param {{ conversa: string, link: string, retorno: string }} templates
 */
export function saveTemplates(templates) {
  const toSave = {};
  Object.keys(DEFAULT_TEMPLATES).forEach((key) => {
    const text = String(templates[key] || '').trim();
    if (text && text !== DEFAULT_TEMPLATES[key]) toSave[key] = text;
  });
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(toSave));
}

/**
 * @param {string} template
 * @param {Object<string, string>} values chave sem chaves: { saudacao: 'Bom dia', ... }
 * @returns {string}
 */
export function renderTemplate(template, values) {
  return template.replace(/\{(\w+)\}/g, (match, key) => (key in values ? values[key] : match));
}
